import PropTypes from "prop-types";

import DerivedLevelsTool, {
  derivedLevelsPropTypes,
  derivedLevelsBaseDefaults,
  derivedLevelsHoverTextDefaults,
} from "./DerivedLevelsTool";
import EachQuadrantLines from "./wrapper/EachQuadrantLines";

// Config sobre DerivedLevelsTool (auditoria 2026-07-17, item 1d);
// a matemática dos quartis vive no EachQuadrantLines
class QuadrantLines extends DerivedLevelsTool {}

QuadrantLines.collectionKey = "quadrantLines";
QuadrantLines.EachComponent = EachQuadrantLines;
QuadrantLines.evoId = "interactive-quadrant-lines";

QuadrantLines.propTypes = {
  ...derivedLevelsPropTypes,
  quadrantLines: PropTypes.array.isRequired,
};

QuadrantLines.defaultProps = {
  ...derivedLevelsBaseDefaults,
  quadrantLines: [],
  hoverText: {
    ...derivedLevelsHoverTextDefaults,
    text: "Clique e arraste para criar Linhas de Quadrante",
  },
};

export default QuadrantLines;
